import { Link } from 'react-router-dom'
import { intakeStatus, intakeTodo, type IntakeSummary } from '@/lib/templateIntakes'
import { fmtAgo } from '@/lib/format'
import { Icon } from '@/components/Icon'

export function IntakeRows({ templates, developer = false }: { templates: IntakeSummary[]; developer?: boolean }) {
  if (!templates.length) return null
  return <div className="rows">{templates.map(template => <Link key={template.template_id}
    className="trow" aria-label={template.title} to={`/${developer ? 'eng' : 'sme'}/templates/${template.template_id}`}>
    <div>
      <div className="title"><span className="template-label"><Icon name="template" size={13} />Template</span>{template.title}</div>
      <div className="subline">Experiment data{developer && ` · ${template.owner_email}`}</div>
      <div className="todo">{intakeTodo(template.status, template.return_note)}</div>
    </div>
    <div className="side"><span className="chip">{intakeStatus(template.status)}</span>
      <span className="when">{fmtAgo(template.updated_at)}</span><span className="arrow">›</span></div>
  </Link>)}</div>
}
